export default [
  {
    type: 'index',
    formItems: [
      {
        label: "页面标题",
        name: "title",
        key: "params",
        stamp: 'input'
      },
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "容器背景色",
        name: "contentBackgroundColor",
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "主题色",
        name: "themeColor",
        key: "style",
        type: "color",
        stamp: 'input',
        help:"用于设置一些标识类的文字颜色"
      },
      {
        label: "容器圆角",
        name: "radius",
        type: "text",
        stamp: 'slider',
        key: "style",
        help:'设置0则为方形'
      },
    ]
  },
  {
    type: 'join',
    formItems: [
      {
        label: "文字",
        name:"title",
        type: "text",
        key: "params",
        stamp: 'input',
        maxlength:6,
        help:"不设置则不显示,最多6个字",
      },
      {
        label: "图标",
        name:"image",
        type: "image",
        key: "style",
        stamp: 'singleImage',
        defaultValue:"web_base_assets/scan/join.png",
        help:"推荐比例160*160 png 图片 "
      },
      {
        label: "文字颜色",
        name:"color",
        type: "color",
        key: "style",
        stamp: 'input',
        
        help:"该模块默认存在当有活动时才会出现"
      }
    ]
  },
  {
    type: 'traceModule',
    formItems: [
      {
        stamp: 'group',
        children:[
          {
            type: 'trace',
            formItems: [
              {
                label: "分类名称",
                name:"title",
                type: "text",
                key: "params",
                stamp: 'input',
                maxlength:6,
                help:"不设置则不显示,最多6个字",
              },
              {
                label: "显示控制",
                name: "showKey",
                type: "text",
                stamp: 'fieldsKey',
                key: "params",
                help:'勾选需要显示的字段',
                options: [
                  { label: '溯源码', value: 'fwcode_sn' },
                  { label: '产品名称', value: 'product_name' },
                  { label: '服务电话', value: 'batch_sn' },
                  { label: '服务信息', value: 'server_phone' },
                  { label: '销售区域', value: 'sale_area' },
                  { label: '监控视频直播', value: 'video' },
                  { label: '产品介绍', value: 'video_is_show' },
                ],
              },
            ]
          },
          {
            type: 'enterprise',
            formItems: [
              {
                label: "分类名称",
                name:"title",
                type: "text",
                key: "params",
                stamp: 'input',
                maxlength:6,
                help:"不设置则不显示,最多6个字",
              },
              {
                label: "显示控制",
                name: "showKey",
                type: "text",
                stamp: 'fieldsKey',
                key: "params",
                help:'勾选需要显示的字段',
                options: [
                  { label: '企业信息', value: 'enterpriseInfo' },
                  { label: '组织结构代码', value: 'company_bar_code' },
                  { label: '营业执照代码', value: 'company_license_no' },
                  { label: '企业地址', value: 'company_business_addr' },
                ],
              },
            ]
          },
        ]
      }
    ]
  },
  {
    type: 'layout',
    formItems: [
      {
        label: "页面标题",
        name: "title",
        key: "params",
        stamp: 'input'
      },
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "容器背景色",
        name: "contentBackgroundColor",
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "主题色",
        name: "themeColor",
        key: "style",
        type: "color",
        stamp: 'input',
        help:"用于设置一些标识类的文字颜色"
      },
    ]
  },
  {
    type: 'banner',
    formItems: [
      {
        label: "图片",
        type: "image",
        key: "data",
        stamp: 'image',
      }
    ]
  },  {
    type: 'windows',
    formItems: [
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "布局",
        name: "class",
        type: "text",
        stamp: 'radio',
        key: "style",
        help: '图片比例建议一致',
        options: [
          { label: '独占一行', value: 'full' },
          { label: '堆积两列', value: 'half' },
          { label: '堆积三列', value: 'third' },
          { label: '堆积四列', value: 'quarter' },
        ],
      },
      {
        label: "图片",
        type: "image",
        key: "data",
        stamp: 'image',
      }
    ]
  },
  {
    type: 'blank',
    formItems: [
      {
        label: "高度",
        name: "height",
        type: "text",
        stamp: 'slider',
        key: "style"
      },
    ]
  },
  {
    type: 'videoModule',
    formItems: [
      // {
      //   label: "视频素材",
      //   name: "video_source",
      //   coverName: "video_cover",
      //   key: "params",
      //   stamp: 'video'
      // },
      {
        label: "自动播放",
        name: "autoplay",
        key: "params",
        stamp: 'radio',
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
      },
      {
        label: "循环播放",
        name: "loop",
        key: "params",
        stamp: 'radio',
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
      },
      {
        label: "显示控件",
        name: "controls",
        key: "params",
        stamp: 'radio',
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
      },
      {
        label: "视频高度",
        name: "height",
        key: "style",
        stamp: 'slider',
        min: 120,
        max: 400,
      },
      {
        label: "容器圆角",
        name: "radius",
        key: "style",
        stamp: 'slider',
        min: 0,
        max: 40,
      },
    ]
  },
  {
    type: 'notice',
    formItems: [
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "文字颜色",
        name: "textColor",
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "文字内容",
        name: "content",
        key: "params",
        type: "text",
        stamp: 'input'
      },
    ]
  },
  {
    type: 'nav',
    formItems: [
      {
        label: "图片导航",
        type: "image",
        key: "data",
        stamp: 'navImage',
      }
    ]
  },
  {
    type: 'bottomNav',
    formItems: [
      {
        label: "容器圆角",
        name: "radius",
        type: "text",
        stamp: 'slider',
        key: "style",
        help:'设置0则为方形'
      },
      {
        label: "图片导航",
        type: "image",
        key: "data",
        stamp: 'navImage',
      }
    ]
  },
  {
    type: 'goods',
    formItems: [
      {
        label: "是否显示商品链接",
        name: "is_show",
        type: "text",
        stamp: 'radio',
        key: "params",
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
      },
      {
        label: "是否显示价格",
        name: "is_show_price",
        type: "text",
        stamp: 'radio',
        key: "params",
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
      },
    ]
  },
  {
    type:"antiCounterfeiting",
    formItems: [
      {
        label: "关联模板",
        name: "antis_fake_tem_title",
        type: "text",
        stamp: 'query',
        key: "params"
      }
    ]
  },
  {
    type: 'trace',
    formItems: [
      {
        label: "是否显示",
        name: "is_show",
        type: "text",
        stamp: 'radio',
        key: "params",
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
      },
      {
        label: "分类名称",
        name:"title",
        type: "text",
        key: "params",
        stamp: 'input',
        maxlength:6,
        help:"不设置则不显示,最多6个字",
      },
      {
        label: "显示控制",
        name: "showKey",
        type: "text",
        stamp: 'fieldsKey',
        key: "params",
        help:'勾选需要显示的字段',
        options: [
          { label: '溯源码', value: 'fwcode_sn' },
          { label: '产品名称', value: 'product_name' },
          { label: '生产批次', value: 'batch_sn' },
          { label: '服务电话', value: 'server_phone' },
          { label: '服务信息', value: 'server_title' },
          { label: '销售区域', value: 'sale_area' },
          { label: '检验报告', value: 'inspection_report' },
          { label: '监控视频直播', value: 'video' },
          { label: '产品介绍', value: 'video_is_show' },
        ],
      },
      {
        label: "是否显示拨打电话",
        name: "is_show_call",
        type: "text",
        stamp: 'radio',
        key: "params",
        options: [
          { label: '开启', value: 1 },
          { label: '关闭', value: 2 },
        ],
      },
    ]
  },
  {
    type: 'enterprise',
    formItems: [
      {
        label: "是否显示",
        name: "is_show",
        type: "text",
        stamp: 'radio',
        key: "params",
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
      },
      {
        label: "分类名称",
        name:"title",
        type: "text",
        key: "params",
        stamp: 'input',
        maxlength:6,
        help:"不设置则不显示,最多6个字",
      },
      {
        label: "显示控制",
        name: "showKey",
        type: "text",
        stamp: 'fieldsKey',
        key: "params",
        help:'勾选需要显示的字段',
        options: [
          { label: '企业信息', value: 'enterpriseInfo' },
          { label: '组织结构代码', value: 'company_bar_code' },
          { label: '营业执照代码', value: 'company_license_no' },
          { label: '企业地址', value: 'company_business_addr' },
        ],
      },
      {
        label: "是否电话号码",
        name: "is_show_phone",
        type: "text",
        stamp: 'radio',
        key: "params",
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
      },
      {
        label: "是否显示拨打电话",
        name: "is_show_call",
        type: "text",
        stamp: 'radio',
        key: "params",
        options: [
          { label: '开启', value: 1 },
          { label: '关闭', value: 2 },
        ],
      },
    ]
  },
]
